import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { ResultsData } from "../../state/ActivityLog/ResultsData";

const updateResultsData: Reducer<ResultsData> = (state: ResultsData = new ResultsData(), action: Action<ActionType, ResultsData>) =>
{
  switch (action.type)
  {
    case ActionType.ACTIVITY_LOG_RESULTS_GET:
      return { results: [...state.results, action.data] };
    case ActionType.ACTIVITY_LOG_RESULTS_RESET:
      return { results: [] };
    default:
      return state;
  }
};

export default updateResultsData;
